import styled from '@app/styled';
import { color, spacing, typography } from '@app/theme';

export const PromoLink = styled.div`
    ${typography('custom.body')};
    margin-top: ${spacing(2)};
`;
export const Title = styled.h6`
    color: ${color('custom.content.primary')};
    margin: 0;
    ${typography('custom.bodyMedium')};
    margin-bottom: ${spacing(3)};
`;
export const Text = styled.div`
    color: ${color('custom.content.secondary')};
    ${typography('custom.body')};
    margin-bottom: ${spacing(1)};
`;
